/**
 * What a caller's onSubmit tells useFormWithRecaptcha to do with the v2 checkbox next.
 * Returning a value (rather than throwing) is the expected-outcome error pattern:
 * a rejected v3/v2 check is a normal branch, not an exception.
 */
export enum RecaptchaFallbackDecision {
    // The submission is resolved and the checkbox should be left as-is: either it succeeded, or the
    // caller surfaced an error WITHOUT spending the v2 token (e.g. client-side field validation, so
    // an already-solved checkbox stays valid for the retry).
    Handled = 'handled',
    // The server rejected the reCAPTCHA token (low v3 score, or a bad/expired v2 token). Reveal the
    // v2 checkbox (escalating from v3) and refresh it so the user solves a fresh one.
    NeedsV2Challenge = 'needs-v2-challenge',
    // The v2 token verified server-side, but the submission then failed for another reason (e.g.
    // "email already registered", wrong password), spending the single-use token. Refresh the
    // checkbox so the retry gets a fresh token. Nothing to escalate — a no-op in v3 mode, where no
    // checkbox is shown.
    RefreshV2Challenge = 'refresh-v2-challenge',
}
